import { setLanguage } from "redux-i18n";
import { all, select, takeEvery, put } from "redux-saga/effects";
import { checkinReset, checkinResetAnswers } from "redux/checkin/actions";
import { questionsReset } from "redux/questions/actions";
import { getUserLanguage } from "redux/ws/selectors";

import questionSagas from "redux/questions/sagas";

function* resetCheckin() {
    // Reset question state
    yield put(questionsReset());

    // Reset answers
    yield put(checkinResetAnswers());

    // Reset language
    const language = yield select(getUserLanguage);
    yield put(setLanguage(language || "en"));
}

export default function* checkinSagas() {
    yield all([questionSagas(), takeEvery(checkinReset, resetCheckin)]);
}
